// extracted by mini-css-extract-plugin
module.exports = {"singleLine":"singleLine--2TC5c","multiLine":"multiLine--3SF_3"};